import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class DateRangeValidationRule extends ValidationRule {
  private fromDate: Date;
  private toDate: Date;

  constructor(key: string, fromDate: Date, toDate: Date) {
    if (!key) {
      key = ValidationTypes.dateRange;
    }

    super(key);

    this.fromDate = fromDate;
    this.toDate = toDate;
  }

  isValid(value: Date): boolean {
    if (value == null) {
      return true;
    }

    value = new Date(value);
    return value >= this.fromDate && value <= this.toDate;
  }
}
